export default "__VITE_ASSET__D$NIiQLL__"